export function getUrlParams(url: string) {
  const getParams = url.split('?')[1]

  const urlParams = new URLSearchParams(getParams)
  const params = Object.fromEntries(urlParams.entries())
  return params
}
